module.exports = __webpack_public_path__ + "static/media/44.08e97f6f.jpg";